import React from 'react';

import { isOrgAdmin, useGetRoles } from '../../hooks/tanstack/useUtilsHook';

import ProjectReview from './ProjectReview';

const ProjectSettings = () => {
  const { projectRole, orgRole } = useGetRoles();

  const isEditable = projectRole === 'project_owner';
  const isDeletable = orgRole && isOrgAdmin(orgRole);

  return (
    <div className="px-12 pb-12 space-y-6">
      <div className="flex justify-between">
        <h1 className="text-2xl font-bold">Project Settings</h1>
      </div>
      <ProjectReview editable={isEditable} deletable={isDeletable} />
    </div>
  );
};

export default ProjectSettings;
